import { dateFormat } from 'common/helpers/dateHelper';

import DeliveryDate from './details/DeliveryDate';
import PaymentMethod from './details/PaymentMethod';
import ShippingInstructions from './details/ShippingInstructions';
import ShippingMethod from './details/ShippingMethod';

const OrderDetails = (props) => {
  const { order, settings } = props;
  return (
    <div className="c7-order__customer-detail">
      <h4>Order information</h4>
      <div>
        <span>
          <strong>Order Information</strong>
          <br />
          Order Number: {order.orderNumber}
          <br />
          Order Date: {dateFormat(order.orderSubmittedDate, settings)}
          <br />
          Payment Status: {order.paymentStatus}
          <br />
          Fulfillment Status: {order.fulfillmentStatus}
        </span>
        <ShippingInstructions
          shippingInstructions={order.shippingInstructions}
        />
      </div>

      <div>
        <ShippingMethod order={order} />
        <PaymentMethod order={order} settings={settings} />
      </div>
      <div>
        <DeliveryDate order={order} settings={settings} />
      </div>
    </div>
  );
};

export default OrderDetails;
